import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
} from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { CommonModule } from '@angular/common';
import { ICellRendererParams } from 'ag-grid-community';
import { UtilSharedModule } from '../../util-shared.module';

export interface DistributedProductIdCellRendererComponentParams
  extends ICellRendererParams<unknown, unknown>,
    DistributedProductIdCellParams {}

export interface DistributedProductIdCellParams {
  isAptitudeProduct: boolean;
  productId: string;
  linkUrl: string;
}

@Component({
    imports: [CommonModule, NgbTooltipModule, UtilSharedModule],
    selector: 'app-distributed-product-id-cell-renderer',
    template: `@if(productId) {
    <div
      class="fw-bold mb-1 text-truncate custom-line-height-cell custom-two-line-cell"
    >
      <span class="fw-bold mb-1">
        @if(isAptitudeProduct) {
        <i
          class="apt-logo-icon"
          data-test-selector="distributed-product-id-aptitude-icon"
        ></i>
        }
        <a
          [href]="linkUrl"
          target="_blank"
          data-test-selector="distributed-product-id"
          >{{ productId }}
        </a>
      </span>
    </div>
    }`,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DistributedProductIdCellRendererComponent
  implements ICellRendererAngularComp
{
  constructor(private changeDetectorRef: ChangeDetectorRef) {}
  isAptitudeProduct!: boolean;
  productId!: string;
  linkUrl!: string;

  agInit({
    productId,
    isAptitudeProduct,
    linkUrl,
  }: DistributedProductIdCellRendererComponentParams): void {
    this.isAptitudeProduct = isAptitudeProduct;
    this.productId = productId;
    this.linkUrl = linkUrl;
    this.changeDetectorRef.detectChanges();
  }

  refresh(): boolean {
    return false;
  }
}
